import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ type, message }) => {
  const getAlertColor = () => {
    switch (type) {
      case 'danger':
        return '#7C1227';
      case 'success':
        return '#28a745';
      case 'warning':
        return '#D2BA7B';
      case 'info':
        return '#4C5454';
      default:
        return '#4C5454';
    }
  };

  return (
    <div 
      className="alert mb-4" 
      style={{ 
        backgroundColor: '#FFFAFA', 
        color: getAlertColor(),
        border: `1px solid ${getAlertColor()}`,
        borderLeft: `5px solid ${getAlertColor()}`,
        borderRadius: '4px',
        padding: '15px 20px'
      }}
      role="alert"
    >
      {message}
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};

export default Alert;
